import i18n from "../i18n";
import { ValueFormatter } from "./ValueFormatter";

export class BooleanFormatter extends ValueFormatter {
  format(value) {
    return value === true ? i18n.t("formatters:bool.true") : i18n.t("formatters:bool.false");
  }
}
